import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthorizationContext } from "contexts/AuthorizationContext";
import "./orgFilter.css";

// Under the organization chip (AB#50180): the last site page opened, which
// opens it again; a switch that pauses the site filter (nothing highlighted,
// the chip greyed out) or resumes it; and a cross that clears it. Nothing
// with no site filter. The compact sidebar shows icons only.
const SiteFilterChip = ({ isCompact = false }) => {
  const navigate = useNavigate();
  const { t } = useTranslation("common");
  const { filteredSite, pausedSite, pauseSiteFilter, resumeSiteFilter, clearSiteFilter } =
    useAuthorizationContext();

  const site = filteredSite ?? pausedSite;
  if (!site) return null;

  const isPaused = !filteredSite;
  const openLabel = t("siteFilter.openSite", { name: site.name });
  const switchLabel = isPaused
    ? t("siteFilter.resumeFilter", { name: site.name })
    : t("siteFilter.pauseFilter", { name: site.name });
  // The site as the Sites list opens it: the organization is the filter's own.
  const siteInfo = { ...site };
  delete siteInfo.orgGuid;
  const openSite = () => navigate("/std/dvcs", { state: { site: siteInfo } });

  return (
    <div
      className={`${isCompact ? "org-filter-chip-compact" : "org-filter-chip"} site-filter-chip ${isPaused ? "is-paused" : ""}`}
      data-testid="site-filter-chip"
    >
      <button
        type="button"
        className="org-filter-chip__open"
        title={openLabel}
        aria-label={openLabel}
        onClick={openSite}
      >
        <i className="ni ni-shop org-filter-chip__icon" aria-hidden="true" />
        {!isCompact && <span className="org-filter-chip__name">{site.name}</span>}
      </button>
      <button
        type="button"
        className="org-filter-chip__switch"
        title={switchLabel}
        aria-label={switchLabel}
        aria-pressed={!isPaused}
        onClick={isPaused ? resumeSiteFilter : pauseSiteFilter}
      >
        <i className={`fas ${isPaused ? "fa-toggle-off" : "fa-toggle-on"}`} aria-hidden="true" />
      </button>
      <button
        type="button"
        className="org-filter-chip__clear"
        title={t("siteFilter.clearFilter")}
        aria-label={t("siteFilter.clearFilter")}
        onClick={clearSiteFilter}
      >
        <i className="fas fa-times" aria-hidden="true" />
      </button>
    </div>
  );
};

SiteFilterChip.propTypes = {
  isCompact: PropTypes.bool,
};

export default SiteFilterChip;
